export const depositBackRouter = [
  {
    path: "/projectPayment/depositBack/list",
    name: "deposit-back-list",
    meta: { title: "保证金退回" },
    component: () =>
      import(/* webpackChunkName: "depositBack" */ "@/views/project-payment/depositBack/list/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/depositBack/create",
    name: "deposit-back-create",
    meta: { title: "新增保证金退回",comName:"projectPaymentDepositBackFormCreate" },
    component: () =>
      import(/* webpackChunkName: "depositBack" */ "@/views/project-payment/depositBack/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/depositBack/edit/:id",
    name: "deposit-back-edit",
    meta: { title: "编辑保证金退回",comName:"projectPaymentDepositBackFormCreate" },
    component: () =>
      import(/* webpackChunkName: "depositBack" */ "@/views/project-payment/depositBack/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/depositBack/detail/:id",
    name: "deposit-back-detail",
    meta: { title: "保证金退回详情" },
    component: () =>
      import(
        /* webpackChunkName: "depositBack" */ "@/views/project-payment/depositBack/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/depositBack/flowPrint/:id",
    name: "deposit-back-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "depositBack" */ "@/views/project-payment/depositBack/flow-print/index.vue"
      ),
  },
];